import React from 'react';
import {
  Box,
  Button,
  Flex,
  Input,
  Text,
  HStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaSearch } from 'react-icons/fa';
import { primaryButtonProps, adminColors } from '../../../theme/adminUi';
import {
  defaultMonthRange,
  rangeLastMonths,
  rangePreviousMonth,
  rangeLastDays,
} from './reportUtils';

const PRESETS = [
  { id: 'month', label: 'Este mes', getRange: defaultMonthRange },
  { id: 'prev', label: 'Mes anterior', getRange: rangePreviousMonth },
  { id: '30', label: '30 días', getRange: () => rangeLastDays(30) },
  { id: '90', label: '90 días', getRange: () => rangeLastDays(90) },
  { id: '12m', label: '12 meses', getRange: () => rangeLastMonths(12) },
];

/**
 * Barra de período personalizado + atajos rápidos.
 */
export default function ReportPeriodBar({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onApply,
  loading = false,
  applyLabel = 'Vista previa',
  description,
}) {
  const bg = useColorModeValue('white', 'gray.800');
  const border = useColorModeValue('gray.200', 'whiteAlpha.300');
  const muted = useColorModeValue('gray.600', 'gray.400');
  const presetBg = useColorModeValue('gray.50', 'whiteAlpha.100');

  const applyPreset = (preset) => {
    const range = preset.getRange();
    onStartDateChange(range.startDate);
    onEndDateChange(range.endDate);
  };

  return (
    <Box
      borderWidth="1px"
      borderColor={border}
      borderRadius="lg"
      bg={bg}
      p={{ base: 3, md: 4 }}
      mb={4}
    >
      {description ? (
        <Text fontSize="sm" color={muted} mb={3} lineHeight="1.5">
          {description}
        </Text>
      ) : null}

      <Flex
        gap={3}
        align={{ base: 'stretch', md: 'flex-end' }}
        flexWrap="wrap"
        mb={3}
      >
        <Box minW="150px">
          <Text fontSize="xs" fontWeight="semibold" color="gray.500" mb={1}>
            Desde
          </Text>
          <Input
            type="date"
            size="sm"
            value={startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            borderRadius="md"
          />
        </Box>
        <Box minW="150px">
          <Text fontSize="xs" fontWeight="semibold" color="gray.500" mb={1}>
            Hasta
          </Text>
          <Input
            type="date"
            size="sm"
            value={endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            borderRadius="md"
          />
        </Box>
        <Button
          {...primaryButtonProps}
          leftIcon={<FaSearch />}
          onClick={onApply}
          isLoading={loading}
          px={4}
        >
          {applyLabel}
        </Button>
      </Flex>

      <HStack spacing={2} flexWrap="wrap">
        <Text fontSize="xs" color="gray.500" mr={1}>
          Atajos:
        </Text>
        {PRESETS.map((preset) => (
          <Button
            key={preset.id}
            size="xs"
            variant="ghost"
            bg={presetBg}
            color={adminColors.primary}
            _hover={{ bg: 'gray.100', color: adminColors.primaryHover }}
            onClick={() => applyPreset(preset)}
          >
            {preset.label}
          </Button>
        ))}
      </HStack>
    </Box>
  );
}
